import React from 'react';
import PropTypes from 'prop-types';
import Box from "../Box/Box";
import Notify from "../../services/Notify";
import Loading from "../Loading/Loading";
import {Col, ControlLabel, FormGroup, Row} from "react-bootstrap";
import UserService from "../../services/UserService";
import FormButtons from "../Form/FormButtons";
import Objects from "../../utils/Objects";

class ProfileForm extends React.Component {

  userService = new UserService();

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    const state = this.state;
    state.loading = true;
    this.setState(state);
    this.userService.getMe().then(
        data => this.setState({loading: false, entity: data}),
        error => {
          const state = {loading: false};
          if (error.response.status === 404) {
            state.message = 'Entidade não encontrada!';
          } else {
            state.message = 'Erro inesperado!';
            Notify.error('Falha o buscar entidade!', error)
          }
          this.setState(state);
        }
    )
  }

  submitForm() {
    const {entity} = this.state;
    entity.name = this.firstName.value;

    if (Objects.nonEmptyOrBlank(this.password.value)) {
      entity.password = this.password.value;
      const password = this.password.value;
      if (password !== this.retryPassword.value) {
        Notify.warning('Senhas não conferem');
        return;
      }
    }

    this.userService.save(entity).then(
        () => {
          this.props.history.push("/");
          Notify.success('Entidade salva');
        },
        (error) => Notify.error('Falha ao salvar entidade:', error));
  }

  render() {
    const {loading, entity = {}, message} = this.state;
    if (loading) {
      return <Loading/>
    }

    if (message) {
      return <h2>{message}</h2>
    }

    return (
        <Box info>
          <form ref={form => (this.form = form)} onSubmit={event => {
            event.preventDefault();
            this.submitForm()
          }}>

            <FormGroup>
              <ControlLabel>Nome</ControlLabel>
              <input
                  type="text"
                  name="firstName"
                  defaultValue={entity.name}
                  ref={firstName => (this.firstName = firstName)}
                  className="form-control"
              />
            </FormGroup>

            <FormGroup>
              <ControlLabel>E-mail</ControlLabel>
              <input
                  type="email"
                  name="emailAddress"
                  disabled={true}
                  defaultValue={entity.email}
                  ref={emailAddress => (this.emailAddress = emailAddress)}
                  className="form-control"
              />
            </FormGroup>

            <Row>
              <Col sm={6} xs={6}>
                <FormGroup>
                  <ControlLabel>Senha</ControlLabel>
                  <input type="password" className="form-control" placeholder="Senha" name="password" ref={value => this.password = value}/>
                </FormGroup>
              </Col>
              <Col sm={6} xs={6}>
                <FormGroup>
                  <ControlLabel>Confirmação de Senha</ControlLabel>
                  <input type="password" className="form-control" placeholder="Repita a senha" name="retryPassword" ref={email => this.retryPassword = email}/>
                </FormGroup>
              </Col>
            </Row>


            <FormButtons history={this.props.history}/>

          </form>
        </Box>
    );
  }
}

ProfileForm.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default ProfileForm;



// WEBPACK FOOTER //
// ./src/component/User/ProfileForm.js